import axios from 'axios'
import store from '@/store'

export const WEB_MAIN_PATH = '/web-main'

function isApiOk(body) {
  return body && (body.code === 0 || body.code === '0')
}

export function normalizePath(url) {
  if (!url || typeof url !== 'string') {
    return ''
  }
  const trimmed = url.trim()
  if (!trimmed) {
    return ''
  }
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`
}

/** 按一级菜单 URL 前缀推断默认落地页（可扩展） */
function moduleDefaultForRootUrl(rootUrl) {
  const url = normalizePath(rootUrl)
  if (url.startsWith('/shopping')) {
    return '/shopping/gds-order'
  }
  if (url.startsWith('/devops')) {
    return '/devops/mg-account'
  }
  if (url.startsWith('/func')) {
    return '/func/clue-list'
  }
  return ''
}

function firstPageFromSubMenus(subs) {
  if (!Array.isArray(subs)) {
    return ''
  }
  for (const sub of subs) {
    for (const child of sub.children || []) {
      const pageUrl = normalizePath(child.url)
      if (pageUrl) {
        return pageUrl
      }
    }
  }
  return ''
}

async function fetchRootMenus() {
  const res = await axios.get('/user-api/mg-function/get-root-menu')
  return isApiOk(res.data) && Array.isArray(res.data.data) ? res.data.data : []
}

async function fetchSubMenus(rootId) {
  if (!rootId) {
    return []
  }
  const res = await axios.get(`/user-api/mg-function/get-sub-menu/${rootId}`)
  return isApiOk(res.data) && Array.isArray(res.data.data) ? res.data.data : []
}

async function resolveFromServerLanding() {
  const res = await axios.get('/user-api/mg-function/get-login-landing')
  if (!isApiOk(res.data) || !res.data.data?.path) {
    return null
  }
  const { rootId, path } = res.data.data
  if (rootId) {
    store.commit('setRootMenu', rootId)
  }
  return normalizePath(path)
}

async function resolveFromRootMenus() {
  const roots = await fetchRootMenus()
  if (!roots.length) {
    return null
  }

  for (const root of roots) {
    const rootId = root.value || root.id
    const rootUrl = normalizePath(root.url)
    if (rootUrl === WEB_MAIN_PATH) {
      continue
    }

    const subs = await fetchSubMenus(rootId)
    const page = firstPageFromSubMenus(subs)
    if (page) {
      store.commit('setRootMenu', rootId)
      return page
    }

    const moduleDefault = moduleDefaultForRootUrl(rootUrl)
    if (moduleDefault) {
      store.commit('setRootMenu', rootId)
      return moduleDefault
    }

    if (rootUrl) {
      store.commit('setRootMenu', rootId)
      return rootUrl
    }
  }

  const webMain = roots.find((root) => normalizePath(root.url) === WEB_MAIN_PATH)
  if (webMain) {
    store.commit('setRootMenu', webMain.value || webMain.id)
    return WEB_MAIN_PATH
  }

  return null
}

export async function fetchAuthorizedMenuRoots() {
  const roots = await fetchRootMenus()
  if (!roots.length) {
    return []
  }

  const assembled = []
  for (const root of roots) {
    const children = await fetchSubMenus(root.value || root.id)
    assembled.push({ ...root, children })
  }
  return assembled
}

export function pickLandingFromRoots(roots) {
  if (!Array.isArray(roots) || !roots.length) {
    return null
  }

  for (const root of roots) {
    const rootUrl = normalizePath(root.url)
    if (rootUrl === WEB_MAIN_PATH) {
      continue
    }
    const page = firstPageFromSubMenus(root.children)
    if (page) {
      return { rootId: root.value || root.id, path: page }
    }
    const moduleDefault = moduleDefaultForRootUrl(rootUrl)
    if (moduleDefault) {
      return { rootId: root.value || root.id, path: moduleDefault }
    }
  }

  const webMain = roots.find((root) => normalizePath(root.url) === WEB_MAIN_PATH)
  if (webMain) {
    return { rootId: webMain.value || webMain.id, path: WEB_MAIN_PATH }
  }
  return null
}

export async function resolveDefaultLandingPath() {
  const serverPath = await resolveFromServerLanding()
  if (serverPath) {
    return serverPath
  }
  return resolveFromRootMenus()
}

export function userHasWebMainMenu(roots) {
  return Array.isArray(roots) && roots.some((root) => normalizePath(root.url) === WEB_MAIN_PATH)
}
